import React from 'react';

export interface SortSummaryProps {
  columnLabel: string;
  sortOrder: 'asc' | 'desc';
  onReset: () => void;
  resetAriaLabel?: string;
}

const SortSummary: React.FC<SortSummaryProps> = ({
  columnLabel,
  sortOrder,
  onReset,
  resetAriaLabel = 'Reset sorting',
}) => (
  <span className="sort-summary">
    <span role="status">
      Sorted by: {columnLabel} ({sortOrder === 'asc' ? 'ascending' : 'descending'})
    </span>
    <button
      type="button"
      className="sort-summary__reset"
      onClick={onReset}
      aria-label={resetAriaLabel}
    >
      <span className="se-icon--close"></span>
    </button>
  </span>
);

export default SortSummary;
